module.exports = __webpack_public_path__ + "static/media/left_arrow_white.5c94e4ba.svg";